<template>
  <v-form ref="bannerEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'banner-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование баннера' : 'Создание баннера'}}</h1>
      </v-col>
      <v-col cols="12">
      <div class="">
        <v-img :src="previewImage(true, bannerImage)" width="655" height="190">
          <template v-slot:placeholder>
            <div class="image-placeholder"></div>
          </template>
        </v-img>
      </div>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-file-input label="Картинка в список блюд"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="3264x756.jpg"
                      append-icon="mdi-attachment"
                      v-model="bannerImage">
        </v-file-input>
        <div class="mobile">
          <v-img :src="previewMobileImage(true, mobileBannerImage)" width="300" height="300">
            <template v-slot:placeholder>
              <div class="image-placeholder"></div>
            </template>
          </v-img>
        </div>
        <v-file-input label="Картинка в список блюд для мобилок"
                      prepend-icon=""
                      class="cursor-pointer"
                      outlined
                      placeholder="1080х1080.jpg"
                      append-icon="mdi-attachment"
                      v-model="mobileBannerImage">
        </v-file-input>
        <v-text-field
                v-model="banner.name"
                label="Название"
                :rules="[rules.required]"
                required
                outlined
        ></v-text-field>
        <v-select
                :items="placeList"
                :item-text="place => place.type_name"
                :item-value="place => place.id"
                v-model="banner.type"
                label="Страница"
                :rules="[rules.requiredSelect]"
                required
                outlined
        ></v-select>
        <v-tabs v-model="tabLang" v-if="banner.type != 'mobile'">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang" v-if="banner.type != 'mobile'">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="banner.title"
                        label="Заголовок"
                        outlined
                ></v-text-field>
                <v-textarea
                        v-model="banner.description"
                        label="Описание"
                        outlined
                ></v-textarea>
                <v-text-field
                        v-model="banner.button"
                        label="Кнопка"
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="banner.title_ua"
                        label="Заголовок"
                        outlined
                ></v-text-field>
                <v-textarea
                        v-model="banner.description_ua"
                        label="Описание"
                        outlined
                ></v-textarea>
                <v-text-field
                        v-model="banner.button_ua"
                        label="Кнопка"
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-text-field
                v-model="banner.url"
                label="Ссылка"
                outlined
        ></v-text-field>
        <v-checkbox v-model="banner.disabled"
          label="Выключить"
        ></v-checkbox>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import BannerService from './../../api/BannerService'
  import CategoryService from "../../api/CategoryService";

  export default {
    name: 'BannerEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      banner: {
        name: '',
        title: '',
        title_ua: '',
        description: '',
        description_ua: '',
        button: '',
        button_ua: '',
        type: '',
        type_name: '',
        url: '',
      },
      bannerImage: null,
      mobileBannerImage: null,
      loading: true,
      loadingButton: false,
      categories: [],
      placeList: [],
    }),
    mounted() {
        CategoryService.list().then(response => {
            this.categories = response.data
            this.fillPlaceList()
        })
        if(this.id) {
            BannerService.get(this.id)
                .then(response => {
                    this.banner = response.data;

                    if (this.banner.image) {
                        this.bannerImage = this.banner.image;
                        this.bannerImage.name = this.banner.image.file
                    }

                    if (this.banner.mobile_image) {
                      this.mobileBannerImage = this.banner.mobile_image;
                      this.mobileBannerImage.name = this.banner.mobile_image.file
                    }
                    this.loading = false
                });
        }
    },
    methods: {
      fillPlaceList() {
          this.placeList.push({id: 'home', type_name: 'Главная'})
          this.placeList.push({id: 'catalog', type_name: 'Каталог'})
          this.placeList.push({id: 'mobile', type_name: 'Мобильное приложение'})
          let _this = this
          this.categories.forEach(function (category) {
            _this.placeList.push({id: 'category-' + category.id, type_name: category.name})
          })
      },
      validate() {
        this.$refs.bannerEditForm.validate()
        if(this.banner.name == '' && this.banner.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.banner.name != '' && this.banner.name_ua == ''){
          this.tabLang = 1;
        }
      },
      previewImage(isList, image) {
        if(this.bannerImage && this.bannerImage.url){
            return this.bannerImage.url
        }
        if(image){
          return URL.createObjectURL(image)
        }
      },
      previewMobileImage(isList, image) {
        if(this.mobileBannerImage && this.mobileBannerImage.url){
          return this.mobileBannerImage.url
        }
        if(image){
          return URL.createObjectURL(image)
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();

        BannerService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Баннер успешно обновлен';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении баннера';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        var formData = this.getData();

        BannerService.create(formData).then(response => {
            this.$router.push({ name: 'banner-edit', params: { id: response.data.id } })
          this.banner.id = response.id
          this.snackbar = true;
          this.snackbarText = 'Баннер создан';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при создании баннера';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          let type_name = this.placeList.find(place => place.id == this.banner.type).type_name

          formData.append('id', this.id);
          formData.append('name', this.banner.name);
          formData.append('title', this.banner.title);
          formData.append('title_ua', this.banner.title_ua);
          formData.append('description', this.banner.description);
          formData.append('button_ua', this.banner.button_ua);
          formData.append('description_ua', this.banner.description_ua);
          formData.append('button', this.banner.button);
          formData.append('type', this.banner.type);
          formData.append('type_name', type_name);
          formData.append('url', this.banner.url);
          formData.append('disabled', (this.banner.disabled ? 1 : 0));
          if(this.bannerImage && !this.bannerImage.url) {
              formData.append('bannerImage', this.bannerImage);
          }
        if(this.mobileBannerImage && !this.mobileBannerImage.url) {
          formData.append('mobileBannerImage', this.mobileBannerImage);
        }

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .banner-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .banner{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
